import styled from "styled-components";
import { useState, useEffect } from "react";
import { IonIcon } from "@ionic/react";
import { shareOutline, closeOutline, add } from "ionicons/icons";

const Wrapper = styled.div<{ higherPosition?: boolean }>`
  position: fixed;
  bottom: ${(props) => (props.higherPosition ? "85px" : "0")};
  width: 100%;
  height: 200px;
  background-color: var(--accent-color-dark);
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;

  .close-button {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 22px;
  }

  .close-button:hover {
    cursor: pointer;
    transform: scale(1.2)translateY(2px);
    transition: 0.2s;
  }

  .plus{
    font-size: 15px;
    border: 1.5px solid white;
    border-radius: 5px;
  }

  ion-icon{
    font-size: 20px;
    transform: translateY(3px);
  }



  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

declare global {
  interface Navigator {
    standalone?: boolean;
  }
}
interface BeforeInstallPromptEvent extends Event {
  prompt: () => void;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}

export default function PWABanner({ loginPage = false }: Props) {
  const [showBanner, setShowBanner] = useState(false);
  const [higherPosition, setHigherPosition] = useState(false);
  const [installPromptEvent, setInstallPromptEvent] =
    useState<BeforeInstallPromptEvent | null>(null);
  useEffect(() => {
    // Check if the device is an iOS device
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      // Check if not in standalone mode
      if (
        !navigator.standalone &&
        !window.matchMedia("(display-mode: standalone)").matches
      ) {
        // If on the login page, don't show the banner
        if (loginPage) {
          setShowBanner(true);
        } else {
          // Check if there's no timestamp in local storage
          const timestamp = localStorage.getItem("pwabannerClosedTimestamp");
          if (!timestamp) {
            setShowBanner(true);
          } else {
            const oneWeek = 7 * 24 * 60 * 60 * 1000;
            const now = new Date().getTime();
            if (now - Number(timestamp) > oneWeek) {
              setShowBanner(true);
            }
          }
        }
      }
    }

    if (!loginPage && window.innerWidth < 800) {
      setHigherPosition(true);
    }
    window.addEventListener('beforeinstallprompt', (e: any) => {
        const beforeInstallEvent = e as BeforeInstallPromptEvent;
        beforeInstallEvent.preventDefault();
        setInstallPromptEvent(beforeInstallEvent);
        setShowBanner(true);
      });
  }, []);


  useEffect(()=>{
    if (installPromptEvent) {
      setShowBanner(true);
    }
  },[])

  function onClose() {
    // Hide the banner
    setShowBanner(false);

    // Set the current timestamp in local storage
    const now = new Date().getTime();
    localStorage.setItem("pwabannerClosedTimestamp", now.toString());
  }

  const handleInstallClick = () => {
    // Hide the banner
    setShowBanner(false);
    // Show the prompt
    if (installPromptEvent) {
      installPromptEvent.prompt();
      // Wait for the user to respond to the prompt
      installPromptEvent.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          const now = new Date().getTime();
          localStorage.setItem("pwabannerClosedTimestamp", now.toString());
        } else {

          const now = new Date().getTime();
          localStorage.setItem("pwabannerClosedTimestamp", now.toString());
        }
        // Clear the saved prompt since it can't be used again
        setInstallPromptEvent(null);
      });
    }
  };

  return (
    <>
      {showBanner && (
        <Wrapper higherPosition={higherPosition}>
          <p><u>This app is optimized to be installed on your device.</u></p>
          <p onClick={() => installPromptEvent && handleInstallClick()}>
            1. Click on{" "}
            {installPromptEvent ? "here" : <IonIcon icon={shareOutline} />}{" "}
            in the menu at the top or bottom of this window
          </p>
          <p onClick={() => installPromptEvent && handleInstallClick()}>
            2. Scroll Down
          </p>
          <p onClick={() => installPromptEvent && handleInstallClick()}>
            3. Click Add to Home Screen{" "}
            {installPromptEvent ? "here" : <IonIcon className="plus" icon={add} />}
          </p>
          <IonIcon
            onClick={onClose}
            className="close-button"
            icon={closeOutline}
          />
        </Wrapper>
      )}
    </>
  );
}

interface Props {
  loginPage?: boolean;
}
